module.exports = "<div class=\"d-flex flex-wrap navigation-panel\" role=\"navigation\">\n  <div class=\"mr-4 mb-4\" @fadeIn *ngFor=\"let button of buttons\">\n    <app-navigation-button\n      [title]=\"button.title\"\n      [text]=\"button.text\"\n      [icon]=\"button.icon\"\n      [isSelected]=\"button.isSelected\"\n      (click)=\"onButtonClick(button)\">\n    </app-navigation-button>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/navigation-panel/navigation-panel.component.html
// module id = ../../../../../src/app/navigation-panel/navigation-panel.component.html
// module chunks = main